import type { TimeSeries } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

interface Props {
  series: TimeSeries;
  alias: string;
}

export const TimeSeriesAliasSquare = (props: Props) => {
  const { alias, series } = props;

  return (
    <ChakraV3.Avatar icon={<></>} boxSize={5} rounded={4} bg={series.color}>
      <ChakraV3.Text fontSize='sm' fontWeight='bold' color='white'>
        {alias}
      </ChakraV3.Text>
    </ChakraV3.Avatar>
  );
};
